"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "handleCurrentUserFilter", {
    enumerable: true,
    get: function() {
        return handleCurrentUserFilter;
    }
});
const handleCurrentUserFilter = (_context, _param)=>{};
